import { gql } from "@apollo/client";

export const GET_ALL_USUARIO_SOLICITANTE = gql`
    query GetAllUsuarioSolicitante{
        allUsuarioSolicitantePrecioMasivo{
            idUsuario,
            nombre,
            apellido
        } 
    }
`;